const EVENT_TYPES = Object.freeze({
    PAGE_VIEW: 'pageView',
    USER_ID: 'userId',
    USER_PROPERTIES: 'userProperties',
    SIGN_IN_PAGE_VISITED: 'signInPageView',
    AI_ASSISTANT_BUTTON_CLICKED: 'aiAssistantButtonClicked',
    QUICK_CHECK_REQUESTED: 'quickCheckRequested',
    REPUTATION_CHECK_REQUESTED: 'reputationCheckRequested',
    HOMEPAGE_VISITED: 'homepageVisited'
});

const AMPLITUDE_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.SIGN_IN_PAGE_VISITED]: 'Sign in page visited',
    [EVENT_TYPES.AI_ASSISTANT_BUTTON_CLICKED]: 'AI Assistant button clicked',
    [EVENT_TYPES.QUICK_CHECK_REQUESTED]: 'Quick check requested',
    [EVENT_TYPES.REPUTATION_CHECK_REQUESTED]: 'Reputation check requested',
    [EVENT_TYPES.HOMEPAGE_VISITED]: 'Homepage visited'
});

const FACEBOOK_EVENT_TYPES = Object.freeze({

});

export {
    EVENT_TYPES,
    AMPLITUDE_EVENT_TYPES,
    FACEBOOK_EVENT_TYPES
};
